import { Skeleton, SkeletonProps } from '@chakra-ui/react'
import { FC, PropsWithChildren, ReactElement } from 'react'
import { usePermissionsCheckerContext, Permission } from '@lib/permissions'

type CheckPermissionsWrapperProps = {
  permissions: Permission[]
  failureComponent?: ReactElement
} & SkeletonProps

const CheckPermissionsWrapper: FC<
  PropsWithChildren<CheckPermissionsWrapperProps>
> = ({ permissions, failureComponent, children, ...props }) => {
  const { isLoading, hasPermissions, isError } = usePermissionsCheckerContext()

  if (isError) return failureComponent ?? null

  const isPermitted = hasPermissions(permissions)

  if (isPermitted || isLoading)
    return (
      <Skeleton isLoaded={!isLoading} fitContent {...props}>
        {children}
      </Skeleton>
    )

  return failureComponent ?? null
}

export default CheckPermissionsWrapper
